// test2968
(2968 && 0);
